import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import useStartExecution from '@App/CampaignExecution/hooks/useStartExecution';

import type { CampaignExecutionType } from '../types';

type Props = {
  execution: CampaignExecutionType;
  handleClose: () => void;
};

const ConfirmDispositionDialog = ({ execution, handleClose }: Props) => {
  const { onStartExecution, loading } = useStartExecution({
    executionId: execution.id,
  });

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja iniciar este atendimento?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text color="fg.muted">
                Após iniciar o atendimento, é necessário que você finalize-o.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" disabled={loading}>Cancelar</Button>
              </Dialog.ActionTrigger>
              <Button bg="green.700" color="white" onClick={onStartExecution} loading={loading}>
                Iniciar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmDispositionDialog;
